var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgOwnRegulation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 94,
    viewBox: "0 0 100 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 90H100V93.3333H0V90Z",
    fill: "#031C2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3333 0L20 58.3333L38.3333 75L100 13.3333V0H78.3333Z",
    fill: "#E62645"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 13.3333L38.3333 75L28.3333 66.6667L95 0H100V13.3333Z",
    fill: "#A7163E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 58.3335L5 91.6668L38.3333 75.0002L20 58.3335Z",
    fill: "#D7AE88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100 48.3332L88.535 59.7982C87.5974 60.7355 86.3258 61.2621 85 61.2621C83.6742 61.2621 82.4026 60.7355 81.465 59.7982L75.2017 53.5348C74.2643 52.5972 73.7377 51.3257 73.7377 49.9998C73.7377 48.674 74.2643 47.4025 75.2017 46.4648L100 21.6665",
    fill: "#EF7C00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75 53.3335L69.6934 58.6402C70.327 59.2526 70.8323 59.9851 71.1799 60.7949C71.5275 61.6047 71.7104 62.4756 71.7178 63.3568C71.7253 64.2381 71.5573 65.1119 71.2235 65.9275C70.8897 66.7431 70.3969 67.4841 69.7738 68.1072C69.1506 68.7304 68.4097 69.2232 67.5941 69.557C66.7785 69.8908 65.9046 70.0588 65.0234 70.0513C64.1422 70.0438 63.2713 69.861 62.4614 69.5134C61.6516 69.1658 60.9191 68.6605 60.3067 68.0268L36.6667 91.6668L69.78 82.6352C72.1117 82.0015 74.2374 80.7697 75.9467 79.0618C78.5443 76.4594 80.0022 72.9321 80 69.2552V58.3335L75 53.3335Z",
    fill: "#B7B7B9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 91.6665L19.445 84.4448L11.7233 76.7231L5 91.6665Z",
    fill: "#4B4A50"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgOwnRegulation);
export default __webpack_public_path__ + "static/media/imgOwnRegulation.31ef6fa7eb3185978e55d4e9be3d9d02.svg";
export { ForwardRef as ReactComponent };